import  { ReactElement } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useButtonStyles from "../../../../styles/useButtonStyles";

interface propTypes {
  title: string;
  onSubmitTitle: string;
  onSubmit: () => void;
  canDisable?: boolean;
  onClose?: () => void;
  content: ReactElement;
  open: boolean;
}

const AlertModal = (props: propTypes) => {
  const {
    title,
    onSubmitTitle,
    onSubmit,
    canDisable = false,
    onClose,
    content,
    open,
  } = props;
  const theme = useTheme();
  const buttonStyles = useButtonStyles();

  return (
    <Dialog open={open} onClose={onClose} sx={{ padding: 4 }}>
      <DialogTitle
        sx={{ color: theme.color?.dark, textAlign: "center", pt: 2 }}
      >
        {title}
      </DialogTitle>
      <DialogContent>{content}</DialogContent>
      <DialogActions>
        <Button
          sx={{ ...buttonStyles.containedSecondary }}
          disabled={canDisable}
          onClick={onSubmit}
        >
          {" "}
          {onSubmitTitle}{" "}
        </Button>
        <Button sx={{ ...buttonStyles.containedSecondary }} onClick={onClose}>
          {" "}
          Close{" "}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
export default AlertModal;
